<template>
    <form-field v-bind="fieldProps">
        <select-input
            v-bind="inputProps"
            :options="options"
            @change="change($event)"
            @emitEvent="emitEvent($event, ['change'])"
        ></select-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'

    export default {
        mixins: [FormFieldMixin],

        props: {
            placeholder: { type: String, default: undefined },
            isNullable: { type: Boolean, default: false },
            fromYear: { type: Number, default: new Date().getFullYear() - 100 },
            toYear: { type: Number, default: new Date().getFullYear() },
        },

        computed: {
            options() {
                return Array(this.toYear - this.fromYear)
                    .fill({})
                    .map((option, index) => ({
                        label: this.toYear - index,
                        value: this.toYear - index,
                    }))
            },
        },
    }
</script>
